import React from "react";
import { PageContainer } from "./RepairsOrders.styled";
import { Paginator, Content, FiltersContainer } from "./components";
import { useRepairOrdersPage } from "../../hooks/useRepairOrdersPage";

const RepairsOrders = () => {
  const {
    loading,
    filtersLoading,
    error,
    isEmpty,
    orders,
    ordersMeta,
    filters,
    filterHandlers,
    filterUI,
    handlePageChange,
    handleItemsPerPageChange,
    handleRefresh,
  } = useRepairOrdersPage();

  return (
    <PageContainer>
      <FiltersContainer
        loading={filtersLoading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
      />
      <Content loading={loading} error={error} isEmpty={isEmpty} orders={orders} onRefresh={handleRefresh} />
      <Paginator
        meta={ordersMeta}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </PageContainer>
  );
};

export default RepairsOrders;